import { ActionButtonProps, Box, BoxProps, ColorOptions, Form, Icon, Spacer } from '@jfs/ui-new'
import { Button } from '../../components/AdminButton'
import { RefCalback } from '@jfs/ui-new/src/comps/Form/types'
import { FC, useEffect, useRef, useState } from 'react'
import { ModalAlertView } from '../../components/ModalAlertView'
import { useLazyApiData, useStores } from '../../data/store'
import { formData } from './formData'

interface PackageToMidFormProps {
  data: any
  onUpdate: () => void
  packageNames: any
  isEditable: boolean
  isDeletable: boolean
  onClose: () => void
}

const PackageToMidForm: FC<PackageToMidFormProps> = (props: PackageToMidFormProps) => {
  const { data, packageNames, onUpdate, isEditable, isDeletable } = props
  const { id } = data
  const [toggle, setToggle] = useState(false)
  const [verifiedMessage, setMerchantVerfied] = useState('')
  const [isLoading, setLoading] = useState(false)

  const { verifyMId, add, update, deletePackageMId, message } = useStores((store) => ({
    verifyMId: store.feePackageToMId.verifyMId,
    add: store.feePackageToMId.add,
    update: store.feePackageToMId.update,
    deletePackageMId: store.feePackageToMId.deletePackage,
    message: store.message.getFormMessage(),
  }))

  const [lazyVerifyMId, { state }] = useLazyApiData(verifyMId)
  const [lazyAdd, lazyAddHandler] = useLazyApiData(add)
  const [lazyUpdate, lazyUpdateHandler] = useLazyApiData(update)
  const [lazyDelete, lazyDeleteHandler] = useLazyApiData(deletePackageMId)

  // useEffect(() => {
  //   setIsBtnValid(state === 'fulfilled')
  // }, [state])
  useEffect(() => {
    if (lazyAddHandler.state === 'fulfilled') {
      onUpdate()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lazyAddHandler])

  useEffect(() => {
    if (lazyUpdateHandler.state === 'fulfilled') {
      onUpdate()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lazyUpdateHandler])

  useEffect(() => {
    if (lazyDeleteHandler.state === 'fulfilled') {
      onUpdate()
      setToggle(false)
    }
    if (lazyDeleteHandler.state === 'rejected') {
      setToggle(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lazyDeleteHandler])

  const formref = useRef<RefCalback>(null)

  const onDelete = () => {
    lazyDelete({ ...data, fileType: 1 })
  }
  const onDismiss = () => {
    setToggle(false)
  }
  const deleteMapping = () => {
    setToggle(true)
  }

  const onChangeText = (text: string) => {
    // formref?.current?.goBack()
    setMerchantVerfied('')
  }

  const onSubmit = (values: any) => {
    lazyAdd({
      mid: values.mid,
      packageName: values.packageName,
      fileType: 1,
    })
  }

  const isloading = () => {
    return lazyAddHandler.state === 'pending' || lazyUpdateHandler.state === 'pending' || isLoading
  }

  //const [isBtnValid, setIsBtnValid] = useState(true)
  const handleActions = ({ values, title, defaultActionButtonOnSubmit, isValid }: ActionButtonProps) => {
    const handleOnPress = () => {
      defaultActionButtonOnSubmit()
    }

    return (
      <Box pv={16} flexDirection="row" align={'center'} justify={'center'}>
        <ModalAlertView
          onPress={onDelete}
          show={toggle}
          onDismiss={onDismiss}
          title="Delete Package To MId"
          buttonTitle="Delete"
          message={`Is this final. This will delete mapping with ID ${id}.`}
          isLoading={lazyDeleteHandler.state === 'pending'}
        />
        {isEditable && (
          <Button
            height={40}
            color={'PRIMARY'}
            title={title}
            onPress={handleOnPress}
            isLoading={isloading()}
            disabled={!isValid}
          />
        )}
        <Spacer direction="horizontal" size={16} />
        {isDeletable && id && (
          <Box
            onPress={deleteMapping}
            bg="RED"
            underlayColor="ERROR"
            p={'MEDIUM'}
            justify={'center'}
            align={'center'}
            borderRadius={4}>
            <Icon id="DELETE" size={24} color="WHITE" />
          </Box>
        )}
      </Box>
    )
  }

  const onMidChange = () => {
    //setIsBtnValid(false)
  }
  return (
    <Box onPress={() => {}} {...styles.formContainer} overflow="auto">
      <Form
        ref={formref}
        formData={formData(packageNames, (mid: any) => lazyVerifyMId(mid), onSubmit, onMidChange)}
        actionButtons={handleActions}
      />
    </Box>
  )
}

export { PackageToMidForm }

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 1,
    height: 1,
  },
  shadowOpacity: 0.1,
  shadowRadius: 4,
  zIndex: 10,
}

const styles = {
  formContainer: {
    underlayColor: 'WHITE',
    height: '100vh',
    overflow: 'auto',
    bg: 'WHITE',
    padding: 'MEDIUM',
    backgroundColor: 'WHITE',
    minWidth: 300,
    maxHeight: 180,
    borderWidth: 1,
    borderTopWidth: 0,
    borderColor: '#e3e6f0' as ColorOptions,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    ...shadow,
  } as BoxProps,
}
